import { Component, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

interface Milestone {
  count: string;
  title: string;
  description: string;
  tier: 'pink' | 'gold';
  icon: SafeHtml;
}

@Component({
  selector: 'app-platforms',
  templateUrl: './platforms.component.html',
  styleUrls: ['./platforms.component.css']
})
export class PlatformsComponent  {

  isNavOpen = false;

  // used by the "$5.99 / $9.99 / $19.99" stacked mini-card previews
  threeCards = [1, 2, 3];
  sixCards = [1, 2, 3, 4, 5, 6];
  nineCards = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  milestones: Milestone[] = [];

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private sanitizer: DomSanitizer) {
    this.milestones = [
      {
        count: '20K',
        title: 'VIRTUAL CONFERENCE',
        description: 'Connect face-to-face from anywhere.',
        tier: 'pink',
        icon: this.icon(`<path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>`)
      },
      {
        count: '40K',
        title: 'MARKETPLACE',
        description: 'Buy, sell & support within the community.',
        tier: 'pink',
        icon: this.icon(`<circle cx="9" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 2-1.58L22 6H6"/>`)
      },
      {
        count: '60K',
        title: 'RADIO DJ, LIVE STREAMING & PODCAST',
        description: 'Listen, watch & connect live.',
        tier: 'pink',
        icon: this.icon(`<path d="M12 1a4 4 0 0 0-4 4v6a4 4 0 0 0 8 0V5a4 4 0 0 0-4-4Z"/><path d="M19 10v1a7 7 0 0 1-14 0v-1"/><path d="M12 18v4M8 22h8"/>`)
      },
      {
        count: '80K',
        title: 'TWEET',
        description: 'Share updates, ideas & engage in real-time.',
        tier: 'pink',
        icon: this.icon(`<path d="M21 5s-1.5.9-2.4 1.1A4.3 4.3 0 0 0 11 9v1A10.5 10.5 0 0 1 2 5s-4 9 5 13a11.7 11.7 0 0 1-7 2c9 5 20 0 20-11.5 0-.28 0-.55-.05-.83A7.7 7.7 0 0 0 22 4.5Z"/>`)
      },
      {
        count: '100K',
        title: 'EVENT PLATFORM',
        description: 'Discover events & create amazing experiences.',
        tier: 'gold',
        icon: this.icon(`<rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/><path d="m9 16 2 2 4-4"/>`)
      },
      {
        count: '120K',
        title: 'APPOINTMENT BOOKING',
        description: 'Book, manage & schedule with ease.',
        tier: 'gold',
        icon: this.icon(`<rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/><path d="M12 14v4"/><path d="M10 16h4"/>`)
      },
      {
        count: '140K',
        title: 'LMS & MORE',
        description: 'Learn, grow & unlock endless possibilities.',
        tier: 'gold',
        icon: this.icon(`<path d="M22 10 12 5 2 10l10 5 10-5Z"/><path d="M6 12v5c0 1.5 3 3 6 3s6-1.5 6-3v-5"/>`)
      }
    ];
  }

  private icon(pathInner: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(
      `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${pathInner}</svg>`
    );
  }

  toggleSection(sectionId: string, show: boolean): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const section = document.getElementById(sectionId);
    const moreBtn = document.getElementById(`${sectionId}_more_btn`);
    const lessBtn = document.getElementById(`${sectionId}_less_btn`);

    if (section && moreBtn && lessBtn) {
      section.style.display = show ? 'block' : 'none';
      moreBtn.style.display = show ? 'none' : 'inline-flex';
      lessBtn.style.display = show ? 'inline-flex' : 'none';
    }
  }
}
